import React, {ReactNode} from "react"

interface HorizontalFieldProps {
	label: string
	children: ReactNode
}

/**
 * Reusable horizontal form field component that provides consistent layout
 * for form fields with labels on the left and inputs on the right.
 */
export function HorizontalField({label, children}: HorizontalFieldProps) {
	return (
		<div className="field is-horizontal">
			<div className="field-label is-normal">
				<label className="label">{label}</label>
			</div>
			<div className="field-body">
				<div className="control">{children}</div>
			</div>
		</div>
	)
}
